import { render, staticRenderFns } from "./LandingLanguageButton.vue?vue&type=template&id=b3d9127e&scoped=true"
import script from "./LandingLanguageButton.vue?vue&type=script&lang=js"
export * from "./LandingLanguageButton.vue?vue&type=script&lang=js"
import style0 from "./LandingLanguageButton.vue?vue&type=style&index=0&id=b3d9127e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d9127e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d9127e')) {
      api.createRecord('b3d9127e', component.options)
    } else {
      api.reload('b3d9127e', component.options)
    }
    module.hot.accept("./LandingLanguageButton.vue?vue&type=template&id=b3d9127e&scoped=true", function () {
      api.rerender('b3d9127e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingLanguageButton.vue"
export default component.exports